module.exports = __webpack_public_path__ + "img/avatar2.09514755.png";